import React, { useState } from "react";
import { DesignThinkingTool } from "../../types";

interface DesignThinkingToolCardProps {
  tool: DesignThinkingTool;
}

const DesignThinkingToolCard: React.FC<DesignThinkingToolCardProps> = ({
  tool,
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = Boolean(tool.image && !imageFailed);

  return (
    <div className="dd-tool-card">
      {showImage ? (
        <img
          src={tool.image || undefined}
          alt={tool.name}
          className="dd-tool-image"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="dd-tool-logo">{tool.logoLetter}</span>
      )}
      <div>
        <div className="dd-tool-card-title">
          <a
            className="dd-tool-link"
            href={tool.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {tool.name}
          </a>
        </div>
        <div className="dd-tool-card-desc">{tool.description}</div>
      </div>
    </div>
  );
};

export default DesignThinkingToolCard;
